import { WorkflowTemplateDetailsState } from "@idw-types/state/workflow-template-details-state";
import { WorkflowTemplateDetailsActionTypes, WorkflowTemplateDetailsActions } from "../actions/workflow-template-details-actions";

export const initialWorkflowTemplateDetailsState: WorkflowTemplateDetailsState = {
    data: {
        isLoading: false,
        workflowTemplate: null
    }
};

export const workflowTemplateDetailsReducer = (
    state: WorkflowTemplateDetailsState = initialWorkflowTemplateDetailsState,
    action: WorkflowTemplateDetailsActions
): WorkflowTemplateDetailsState => {
    switch (action.type) {
        // Workflow Template Details
        case WorkflowTemplateDetailsActionTypes.SET_WORKFLOW_TEMPLATE_DETAILS_LOADING:
            return {
                ...state,
                data: {
                    ...(action.payload.isLoading
                        ? { ...initialWorkflowTemplateDetailsState.data }
                        : { ...state.data }),
                    isLoading: action.payload.isLoading
                }
            };
        case WorkflowTemplateDetailsActionTypes.SET_WORKFLOW_TEMPLATE_DETAILS:
            return {
                ...state,
                data: {
                    workflowTemplate: action.payload.workflowTemplate,
                    isLoading: false
                }
            };
        default:
            return state;
    }
};